import DescritoresIndex from "@/Pages/Descritores/index.vue";
import DescritoresForm from "@/Pages/Descritores/DescritoresForm.vue";

export default [
  {
    path: "/descritores",
    name: "descritores.index",
    component: DescritoresIndex,
  },
  {
    path: "/descritores/criar",
    name: "descritores.create",
    component: DescritoresForm,
    props: { editing: false },
  },
  {
    path: "/descritores/:grupoId/editar",
    name: "descritores.edit",
    component: DescritoresForm,
    props: (route) => ({
      editing: true,
      grupoId: parseInt(route.params.grupoId, 10),
    }),
  },
];
